import React, { useContext } from 'react'
import SubHeaderOnProfContent from './SubHeaderOnProfContent'
import InterestedTabs from './InterestedTabs'
import ProfessionalsInvolved from './ProfessionalsInvolved'
import IconsOnListView from './IconsOnListView'
import LegalDateCaseInfo from './LegalDateCaseInfo'
import { Context } from 'Context/Context'
import useIsMobile from 'Hooks/useIsMobile'
import { getCaseType } from 'Utils'
import CloseIcon from 'Components/Icons/CloseIcon'

function HeaderOnProfContent({attorney, onMainModalClose, isResponseReceived, caseData, caseDetails, reqRevCountArr, onDownload, downloadButtonRef, hasAccess, isCaseOpen, setUpdateComp, updateCaseResponse, setRefreshList, setCloseMsg, onClose}) {
 const {userDetails} = useContext(Context);
 const isMobile = useIsMobile();
  const userInfo = attorney ? attorney.userId : userDetails;
  return (
    <>
        <div className='text-[22px] p-2 lg:p-8 flex flex-col bg-sky-100 border-b-2 w-full items-start justify-between'>

          <div className='lg:mb-4 lg:flex-row flex-col flex text-sm w-full justify-between items-center'>
            <div className='relative flex-col text-green-700 w-full text-sm lg:text-lg font-bold flex'>
              {isMobile ? 
              <div className='flex justify-between text-sm'>
                <div>
                {getCaseType(caseDetails?.caseType)} - {caseDetails?.caseNumber}
                </div>
                <div onClick={onMainModalClose}>
                  <CloseIcon  />
                </div>
              </div>
              :
              <LegalDateCaseInfo
              userInfo={userInfo}
              detail={caseDetails}
              onAttorney = {true}
              />}
               <div className='text-sm mb-2 flex justify-between'>
              <ProfessionalsInvolved reqRevCountArr={reqRevCountArr} detail={caseDetails} leaveExtraTags={true} attorney={attorney}/>
              {hasAccess && 
                // (!isCaseOpen && caseDetails?.caseToProfStatus !== 5 ?
                  (!isCaseOpen ?   
                    <></>
                    : 
                    <div className='w-full  flex justify-end'>
                    {/* <InterestedTabs caseDetails={caseDetails}  updateCaseResponse={updateCaseResponse}/> */}
                  
                    <IconsOnListView 
                    onMainModalClose={onMainModalClose}
                    setRefreshList={setRefreshList}
                    setCloseMsg={setCloseMsg}
                    inDetailsPage={true}
                    updateCaseResponse={updateCaseResponse}
                    detail={{...caseDetails, ...{"userId": caseData.userId, "caseInterest": caseData.caseInterest}}} caseData={caseData} attorney={attorney} setUpdateComp={setUpdateComp}/>
                    </div>
                  )
                }
              </div>
            </div>
             
             
              
            </div>
            <SubHeaderOnProfContent
            attorney={attorney} 
            caseDetails={caseDetails} 
            onDownload = {onDownload} 
            downloadButtonRef = {downloadButtonRef}
            hasAccess={hasAccess}
            isCaseOpen={isCaseOpen}
            isResponseReceived={isResponseReceived}
            />
            
            
            
                {/* <Link to="/casesFeed/3">
                    <CloseIcon/>
                </Link> */}
            
        </div>
    </>
  )
}

export default HeaderOnProfContent